export default {
  USERNAME: 'username',
  CURRENT_PASSWORD: 'password',
  ACCEPT_TERMS: 'acceptTerms',
  CITIZEN: 'citizen',
}
